// extracted by mini-css-extract-plugin
export var closeButton = "_ld-1";
export var closeX = "_ld-3";
export var container = "_ld-0";
export var image = "_ld-2";